import { useEffect } from "react";
import {
  EVENT_SET_QUICK_SEARCH_VALUE,
  subscribeEvent,
  unsubscribeEvent,
} from "../utils/events";

const useColumnSearchListener = (columnSearch, forceSearch, publishEvents) => {
  useEffect(() => {
    const handleCustomEvent = ({ detail: { columnName, searchValue } }) => {
      columnSearch({
        columnName,
        searchValue,
      });
      forceSearch();
    };

    if (publishEvents) {
      subscribeEvent(EVENT_SET_QUICK_SEARCH_VALUE, handleCustomEvent);
    }

    // Clean up event listener on component unmount
    return () => {
      if (publishEvents) {
        unsubscribeEvent(EVENT_SET_QUICK_SEARCH_VALUE, handleCustomEvent);
      }
    };
  }, [columnSearch, forceSearch, publishEvents]);
};

export default useColumnSearchListener;
